import React from "react";
import SlidingTabBar from "../../../components/core/SlidingTabBar";
import CreatePost from "./CreatePost";
import { LanguageTranslation } from "../../../components/language-translation/LanguageTranslation";
import { Tab } from "../../../interface/Tabs";
import { languageIdSelector } from "../../../redux/slices/website/languageSlice";
import { useSelector } from "react-redux";
import CreateReel from "../reel/CreateReel";

const CreateLayout = () => {
  const language = useSelector(languageIdSelector);
  const langId = language?.languageId ?? "fr";

  const tabs: Tab[] = [
    {
      id: "createPost",
      name:
        LanguageTranslation({
          labelName: "create_new_post",
          languageCode: langId,
        }) || "Create Post",
      content: <CreatePost />,
    },
    {
      id: "createReel",
      name:
        LanguageTranslation({
          labelName: "create_new_reel",
          languageCode: langId,
        }) || "Create Reel",
      content: <CreateReel />,
    },
  ];
  return (
    <div className="w-full">
      {" "}
      <SlidingTabBar tabs={tabs} borderedTab />
    </div>
  );
};
export default CreateLayout;
